"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectListItemTypes = void 0;
var SelectListItemTypes = {
  Normal: 'normal',
  Select: 'select',
  Checkbox: 'checkbox'
};
exports.SelectListItemTypes = SelectListItemTypes;